import React from 'react';
import { getShopifyAssetUrl } from '../../../utils/utils';

const FooterSnapchatIcon = (): JSX.Element => (
<img src={getShopifyAssetUrl('snapchat.png')} />
);

export default FooterSnapchatIcon;
